import * as React from "react";
import type { SVGProps } from "react";
const SvgBuilding = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill={props.color || "none"}
    viewBox="0 0 12 12"
    {...props}
  >
    <path d="M11.625 9.75h-.75V4.5a.375.375 0 0 0 0-.75h-2.25v-1.5a.375.375 0 0 0 0-.75h-6.75a.375.375 0 1 0 0 .75v7.5h-.75a.375.375 0 0 0 0 .75h10.5a.375.375 0 0 0 0-.75M3.75 3.375h.75a.375.375 0 1 1 0 .75h-.75a.375.375 0 1 1 0-.75m-.375 2.25a.375.375 0 0 1 .375-.375h.75a.375.375 0 1 1 0 .75h-.75a.375.375 0 0 1-.375-.375m3 4.125h-2.25V7.5h2.25zM6.75 6H6a.375.375 0 1 1 0-.75h.75a.375.375 0 0 1 0 .75m0-1.875H6a.375.375 0 1 1 0-.75h.75a.375.375 0 0 1 0 .75m3.375 5.625h-1.5V4.5h1.5z" />
  </svg>
);
export default SvgBuilding;
